import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 2rem;
`;
export const TimeHeader = styled.div`
  text-align: center;
`;
export const TimeBox = styled.div`
  display: flex;
  justify-content: center;
  gap: 0 12px;
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -0.7px;
  color: ${({ theme }) => theme.palette.brand300};
  ${({ theme }) => theme.typography('$title_01', 'bold')};
`;

export const TimeDivider = styled.div`
  color: ${({ theme }) => theme.palette.grayscale800};
  ${({ theme }) => theme.typography('$title_01')};
`;

export const DateBox = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.5px;
  color: #948f9e;
`;

export const LabeledInfo = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
`;

export const LabeledInfoTitle = styled.div`
  color: ${({ theme }) => theme.palette.grayscale500};
  ${({ theme }) => theme.typography('$body_02')};
`;

export const LabeledInfoDescription = styled.div`
  color: ${({ theme }) => theme.palette.grayscale400};
  ${({ theme }) => theme.typography('$headline_01')};
`;

export const TextAreaBox = styled.div`
  margin-top: 22px;

  > div {
    margin-bottom: 10px;
  }
`;

export const ButtonBox = styled.div`
  max-width: var(--max-width);
  display: flex;
  gap: 12px;
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translate3d(-50%, 0, 0);
  padding: 0 20px 20px;

  button {
    width: 100%;
  }
`;

export const DropdownWrapper = styled.div`
  position: absolute;
  top: 54px;
  right: 8px;
  display: flex;
  width: 160px;
  padding: 16px 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  padding: 0 12px;
  background: #373245;
`;

export const DropdownButton = styled.button`
  width: 100%;
  border-bottom: 1px solid #413d50;
  color: #d7d3de;
  color: #d7d3de;
  font-size: 17px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.425px;
  text-align: center;
  padding: 16px 0;

  &:last-child {
    border-bottom-width: 0;
  }
`;

export const DropdownButtonDelete = styled(DropdownButton)`
  color: #e13a3a;
`;

export const DropdownMenuWrapper = styled.div`
  position: relative;
`;

export const ModalButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 0 12px;
  padding: 0 12px 12px;

  button {
    width: 100%;
  }
`;
